// src/App.js
import React, { useState } from "react";
import styled from "styled-components";
import { GlobalStyles } from "./styles/GlobalStyles";
import Navbar from "./components/Navbar";
import Sidebar from "./components/Sidebar";
import NewsFeed from "./components/NewsFeed";
import TruthAIToken from "./components/TruthAIToken";

import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

const Layout = styled.div`
  display: flex;
`;

function App() {
  const [filter, setFilter] = useState("All");

  return (
    <>
      <GlobalStyles />
      <Router>
        <Navbar />
        <Layout>
          {/* Pass filter + setFilter to Sidebar */}
          <Sidebar currentFilter={filter} setFilter={setFilter} />
          
          {/* Main content area (Routes) */}
          <Routes>
            {/* News feed at "/" */}
            <Route 
              path="/" 
              element={<NewsFeed currentFilter={filter} />} 
            />
            {/* Token info page at "/truth-ai-token" */}
            <Route 
              path="/truth-ai-token" 
              element={<TruthAIToken />} 
            />
          </Routes>
        </Layout>
      </Router>
    </>
  );
}

export default App;
